import React from 'react';
import BpChat from '../../../components/BpChat';

// Seller inbox — the same ViBirr conversations, inside the dashboard.
export default function Messages() {
  return (
    <>
      <h2 style={{ fontWeight: 800, marginBottom: 4 }}>Messages</h2>
      <p className="text-muted" style={{ marginBottom: 18 }}>
        Chat with your customers — conversations are synced with ViBirr and BirrWallet.
      </p>
      <div className="bp-chat-page">
        <BpChat inline />
      </div>
    </>
  );
}
